import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    developer: null,
    isLoading: null,
    singleDeveloper: null,
}

export const fetchDeveloper = createAsyncThunk(
    "fetchDeveloper",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/developer/fetch-all-developer?page=${body.page}&search=${body.search}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

export const addDevelopers = createAsyncThunk(
    "addDevelopers",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                "/realestate/developer/add-developer",
                data

            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const checkEmailAddress = createAsyncThunk(
    "checkEmailAddress",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                `/realestate/developer/check-email-developer?developer_email_address=${body?.developer_email_address}`,

            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const checkMobileNumber = createAsyncThunk(
    "checkMobileNumber",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                `/realestate/developer/check-mobile-developer?developer_mobile_number=${body?.developer_mobile_number}`,

            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);


// {Delete Campaign list}
export const deleteDeveloperDetails = createAsyncThunk(
    "deleteDeveloperDetails",
    async (developer_id) => {
        try {
            const response = await instance.delete(
                `/realestate/developer/delete-developer?developer_id=${developer_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

// {single property}
export const fetchSingleDeveloper = createAsyncThunk(
    "fetchSingleDeveloper",
    async (developer_id, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/developer/fetch-single-developer?developer_id=${developer_id}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)


// {Update properties}
export const updateDeveloper = createAsyncThunk(
    "updateDeveloper",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(`/realestate/developer/update-developer`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);


export const DeveloperSlice = createSlice({
    name: 'DeveloperSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDeveloper.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchDeveloper.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload.count;
        })
        builder.addCase(fetchDeveloper.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(addDevelopers.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(addDevelopers.fulfilled, (state, action) => {
            state.loading = false;
            state.developer = action.payload

        })
        builder.addCase(addDevelopers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });


        builder.addCase(updateDeveloper.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updateDeveloper.fulfilled, (state, action) => {
            state.loading = false;
            state.developer = action.payload

        })
        builder.addCase(updateDeveloper.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });


        builder.addCase(deleteDeveloperDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(deleteDeveloperDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.developer = action.payload

        })
        builder.addCase(deleteDeveloperDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(checkEmailAddress.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(checkEmailAddress.fulfilled, (state, action) => {
            state.isLoading = false;
            state.developer = action.payload

        })
        builder.addCase(checkEmailAddress.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(checkMobileNumber.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(checkMobileNumber.fulfilled, (state, action) => {
            state.isLoading = false;
            state.developer = action.payload

        })
        builder.addCase(checkMobileNumber.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload?.data;
        });


        builder.addCase(fetchSingleDeveloper.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchSingleDeveloper.fulfilled, (state, action) => {
            state.loading = false;
            state.singleDeveloper = action.payload

        })
        builder.addCase(fetchSingleDeveloper.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

    },

})

export default DeveloperSlice.reducer;